<template><div class="main">
  <template v-if="user === 0">
    <sticky-bar>Connecting ...</sticky-bar>
    <Loading />
  </template>
  <template v-else>
    <sticky-bar>Login</sticky-bar>
    <form ref="loginForm" action="/user" method="POST">
    <input type="hidden" name="action" value="login" />
    <input type="hidden" name="csrfmiddlewaretoken" :value="csrftoken" />
    <table>
    <tr><th>Username:</th>
      <td><input
              name="username"
              type="text"
              v-model="username"
              @keydown.enter="$refs.password.focus()"
            /></td></tr>
     <tr><th>Password:</th>
      <td><input
              name="password"
              type="password"
              v-model="password"
              ref="password"
              @keydown.enter="login"
            /></td></tr>
     <tr><td></td><td>
       <button @click="login">Log in</button>
     </td></tr>
     </table>
     <router-link to="/password-reset">Forgot your password? Click here to reset it.</router-link>
     </form>
   </template>
</div></template>
<script>
import Cookies from 'js-cookie'
import { mapState } from 'vuex'
import Loading from './Loading'
import StickyBar from './StickyBar'
export default {
  name: 'login',
  components: {
    Loading,
    StickyBar,
  },
  data () {
    return {
      username: '',
      password: '',
    }
  },
  methods: {
    login() {
      this.$refs.loginForm.submit()
    },
  },
  computed: {
    ...mapState(['user']),
    csrftoken: () => Cookies.get('csrftoken'),
  },
  watch: {
    '$store.state.user': function(u) {
      if (this.$route.path !== '/login')
        return
      if (!this.user)
        return
      if (this.$route.query.n)
        this.$router.push(decodeURI(this.$route.query.n))
      else
        this.$router.push('/')
    },
  },
}
</script>
<style lang="scss" scoped>

form { margin: 10px 20px; }
table { border-collapse: collapse; margin-bottom: 10px; }
th { text-align: left; padding-right: 10px; }
th, td { padding-bottom: 5px; }
.loading { padding: 30px; width: 30px; height: 30px; }

</style>
